import { render, staticRenderFns } from "./PwChangeView.vue?vue&type=template&id=e5bf56f0&scoped=true&"
import script from "./PwChangeView.vue?vue&type=script&lang=js&"
export * from "./PwChangeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bf56f0",
  null
  
)

export default component.exports